export const styles = ({ customStyle }) => {
  return {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    userSelect: 'none',
    ...customStyle,
  };
};
